'use strict';

var $ 		= require('jquery');
var logger 	= require('../utils/logger.js');

var popStateCallbacks = [];

window.onpopstate = function(e) {
	logger.info('Popstate event', e.state);

	var index, callback;
	for (index = 0; index < popStateCallbacks.length; index++) {
		callback = popStateCallbacks[index];
		if ($.isFunction(callback)) {
			callback(e.state);
		}
	}
};

module.exports = {
	onStateChange: function (func) {
		popStateCallbacks.push(func);
	},

	setState: function (data) {
		var result = false;
		
		if (window.history && window.history.replaceState) {
			result = true;
			window.history.replaceState(data, null);
		}

		return result;
	},

	setUrl: function (url, title, data) {
		var result = false;

		if (window.history && window.history.pushState) {
			result = true;
			window.history.pushState(data, title, url);
		}

		return result;
	}
};